import React from 'react'
import { __DEV__ } from '@mote/helpers/constants'
import { Dialog } from '../dialog/dialog'
import {
  DialogCloseButton as DrawerCloseButton,
  DialogContainer as DrawerContainer,
  DialogContent as DrawerContent,
  DialogFooter as DrawerFooter,
  DialogHeader as DrawerHeader,
  DialogOverlay as DrawerOverlay
} from '../dialog/dialog'

export const Drawer = React.forwardRef((props, ref) => {
  const { isOpen, onClose, placement = 'left', children, ...rest } = props

  return (
    <Dialog
      ref={ref}
      isOpen={isOpen}
      onClose={onClose}
      placement={placement}
      {...rest}
      isDrawer
    >
      {children}
    </Dialog>
  )
})

if (__DEV__) {
  Drawer.displayName = 'Drawer'
}

Drawer.Overlay = DrawerOverlay
Drawer.Container = DrawerContainer
Drawer.CloseButton = DrawerCloseButton
Drawer.Header = DrawerHeader
Drawer.Content = DrawerContent
Drawer.Footer = DrawerFooter

export {
  DrawerCloseButton,
  DrawerContainer,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay
}
